class LoginController {
  /*@ngInject*/
  constructor(Auth, User, $state, $stateParams, $location, $translate, UsersService, $cookies) {
    this.Auth = Auth;
    this.User = User;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.UsersService = UsersService;
    this.$cookies = $cookies;

    if (Auth.isAuthenticated()) {
      this.$state.go('home')
    }
    this.$translate = $translate;

    this.model = {
      successMessage: null,
      errorMessage: null,
    }
  }

  $onInit() {
    if (!this.$stateParams.userId) {
      return this.$state.go('login');
    }
    this.send2FACode();
  }

  send2FACode() {
    this.model.loading = true;
    this.model.code = null;
    this.UsersService.send2FACode(this.$stateParams.userId)
      .then((data) => {
        delete this.model.errorMessage;
        this.model.successMessage = data.message;
      })
      .catch((err) => {
        delete this.model.successMessage;
        this.model.errorMessage = err.data.message;
      })
      .finally(() => {
        this.model.loading = false;
        document.getElementById('code2FA').focus();
      })
  }

  verify2FACode() {
    this.model.loading = true;
    this.UsersService.verify2FACode(this.$stateParams.userId, this.model.code)
      .then((data) => {
        this.$cookies.putObject('user', data);
        localStorage.setItem('user', data.id);
        localStorage.setItem('loginTime', new Date().getTime());
        localStorage.setItem('email', data.email);
        localStorage.setItem('name', data.name);
        this.User.setUser(data);
        this.$translate.use(data.languageId.id || data.languageId);

        if (Object.keys(this.User.getPrevState()).length > 0) {
          let data = this.User.getPrevState();
          let url = data['hash'];
          this.User.setPrevState('');
          this.$location.path(url.substr(2));
        } else {
          this.$state.go('home');
        }
      })
      .catch((err) => {
        delete this.model.successMessage;
        this.model.errorMessage = err.data.message;
      })
      .finally(() => {
        this.model.loading = false;
      })
  }

}

export default LoginController;


// WEBPACK FOOTER //
// ./client/app/components/verify_2FA_code/verify_2FA_code.controller.js